import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Dropdown from 'components/shared/dropdown/Dropdown';
import TextArea from 'components/shared/input/TextArea';
import { fwoStatusList } from 'services/utils/field-work-order-util';
import './FieldWorkOrderDetails.css';

class FieldWorkOrderGCForm extends Component {
  static propTypes = {
    fieldWorkOrderForm: PropTypes.shape({}),
    handleAttributeChange: PropTypes.func.isRequired,
    showErrorMessage: PropTypes.bool.isRequired,
  };

  missingField(value) {
    const { showErrorMessage } = this.props;
    return !value && showErrorMessage;
  }

  render() {
    const { fieldWorkOrderForm, handleAttributeChange } = this.props;
    let statusList = [...fwoStatusList];
    statusList = statusList.filter((s) => s.value !== 'pending');
    return (
      <div>
        <div className="fwo-form-field">
          <label className="fwo-field-label">Status</label>
          <div
            className={classnames({
              'field-work-order-dropdown': true,
              'field-work-order-form-error-field': this.missingField(
                fieldWorkOrderForm.fwoStatus
              ),
            })}
          >
            <Dropdown
              options={statusList}
              placeholder="Select status"
              value={fieldWorkOrderForm.fwoStatus}
              onChange={(value) => handleAttributeChange('fwoStatus', value)}
            />
          </div>
        </div>
        {fieldWorkOrderForm.fwoStatus &&
          fieldWorkOrderForm.fwoStatus.value === 'denied' && (
            <div className="fwo-form-field">
              <label className="fwo-field-label">Denied reason</label>
              <TextArea
                className={classnames({
                  'text-area-input': true,
                  'field-work-order-form-error-field': this.missingField(
                    fieldWorkOrderForm.fwoDeniedReason
                  ),
                })}
                onChange={handleAttributeChange.bind(null, 'fwoDeniedReason')}
                value={fieldWorkOrderForm.fwoDeniedReason || ''}
              />
            </div>
          )}
      </div>
    );
  }
}

export default FieldWorkOrderGCForm;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/FieldWorkOrderGCForm.js